import React from 'react';
import transformTemplateData from 'utils/transformTemplateData';
import ContentfulSection from '../ContentfulSection';

const ContentfulLayout = props => {
  const data = transformTemplateData(props);
  return <ContentfulSection {...data} />;
};

export default ContentfulLayout;
